

import useModalInfoEmpleado from '../hooks/useModalInfoEmpleado'
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import url from '../api/url';
import Badge from 'react-bootstrap/Badge';


const ModalInfoEmpleado = () => {

    const { SERVIDOR } = url()
    const { infoEmpleado, nombreEmpleado, domicilio, domicilioFiscal,
        traerTodo, nombreArchivo, escolaridadesUsuario, contactos, expDocente,
        expSectorProductivo, lentes, estudiosActuales, problemas, hijos, enlaceTitulo,
        archivosTodos, tipoArchivo, carpeta, aceptado, cuentaBancaria } = useModalInfoEmpleado()

    function esTitulado(a) {
        if (a === 0) {
            return 'No';
        } else if (a === 1) {
            return 'Si';
        }
    }

    return (
        <>
            <div className="modal fade" id="modalEmpleados" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel" onClick={traerTodo}>
                                {nombreEmpleado.nombre + ' ' + nombreEmpleado.apellido}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">

                            { aceptado
                                ? <Badge bg="success">Aviso de privacidad aceptado</Badge>
                                : <Badge bg="warning" text='dark'>No ha aceptado el aviso de privacidad</Badge> }

                            {/* información personal */}
                            <Card className='mt-3'>
                                <Card.Header>Información personal</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <th width='30%'>Fecha de ingreso</th>
                                                <td align='left'>{infoEmpleado.fecha_ingreso}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>RFC</th>
                                                <td align='left'>{infoEmpleado.rfc}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>NSS</th>
                                                <td align='left'>{infoEmpleado.nss}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>CURP</th>
                                                <td align='left'>{infoEmpleado.curp}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Fecha de nacimiento</th>
                                                <td align='left'>{infoEmpleado.fnac}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Edad</th>
                                                <td align='left'>{infoEmpleado.edad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Nacionalidad</th>
                                                <td align='left'>{infoEmpleado.nacionalidad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Estado civil</th>
                                                <td align='left'>{infoEmpleado.estado_civil}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Sexo</th>
                                                <td align='left'>{infoEmpleado.sexo}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Teléfono</th>
                                                <td align='left'>{infoEmpleado.tel}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Celular</th>
                                                <td align='left'>{infoEmpleado.cel}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Email personal</th>
                                                <td align='left'>{infoEmpleado.email_personal}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Fecha de registro</th>
                                                <td align='left'>{infoEmpleado.fecha_registro}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Lugar de nacimiento</th>
                                                <td align='left'>{infoEmpleado.lugar_de_nacimiento ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            {/* domicilio */}
                            <Card className='mt-3'>
                                <Card.Header>Domicilio</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <th width='30%'>Calle</th>
                                                <td align='left'>{domicilio.calle}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Número</th>
                                                <td align='left'>{domicilio.numero}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Ciudad</th>
                                                <td align='left'>{domicilio.ciudad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Estado</th>
                                                <td align='left'>{domicilio.estado}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%' align='right'>Código postal</th>
                                                <td align='left'>{domicilio.codigo_postal}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%' align='right'>Colonia</th>
                                                <td align='left'>{domicilio.colonia}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            {/* domicilio fiscal */}
                            <Card className='mt-3'>
                                <Card.Header>Domicilio fiscal</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <th width='30%'>Código postal</th>
                                                <td align='left'>{domicilioFiscal.codigo_postal}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Código fiscal</th>
                                                <td align='left'>{domicilioFiscal.codigo_fiscal}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Tipo de vialidad</th>
                                                <td align='left'>{domicilioFiscal.tipo_vialidad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Nombre de vialidad</th>
                                                <td align='left'>{domicilioFiscal.nombre_vialidad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Número exterior</th>
                                                <td align='left'>{domicilioFiscal.numero_exterior}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Número interior</th>
                                                <td align='left'>{domicilioFiscal.numero_interior}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Nombre colonia</th>
                                                <td align='left'>{domicilioFiscal.nombre_colonia}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Nombre localidad</th>
                                                <td align='left'>{domicilioFiscal.nombre_localidad}</td>
                                            </tr>
                                            <tr>
                                                <th width='30%'>Municipio</th>
                                                <td align='left'>{domicilioFiscal.municipio}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            {/* archivos */}
                            <Card className='mt-3'>
                                <Card.Header>CV y documentos</Card.Header>
                                <Card.Body>
                                    <Alert variant='info'>
                                        {/* eslint-disable-next-line */}
                                        {nombreArchivo == 'vacio' ? (
                                            <span>sin archivo</span>
                                        ) : (
                                            <a href={`${SERVIDOR}/archivos/${nombreArchivo}`} target='_blank' rel='noreferrer'>
                                                {nombreArchivo}
                                            </a>
                                        )}
                                    </Alert>

                                    <Table>
                                        <tbody>
                                            { archivosTodos.map( (e, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <a href={ `${SERVIDOR}/archivos/${carpeta}/${e.nombre_archivo}` } target='_blank' rel='noreferrer'>
                                                            { tipoArchivo( e.tipo ) }
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                </Card.Body>
                            </Card>

                            {/* escolaridades */}
                            <Card className='mt-3'>
                                <Card.Header>Escolaridades</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Escolaridad</th>
                                                <th>Carrera</th>
                                                <th>Escuela</th>
                                                <th>Cédula</th>
                                                <th>¿Es titulado?</th>
                                                <th>Archivo cédula</th>
                                                <th>Archivo título</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {escolaridadesUsuario.map((e, i) => (
                                                <tr key={ i }>
                                                    <td>{ e.escolaridad }</td>
                                                    <td>{ e.carrera }</td>
                                                    <td>{ e.escuela }</td>
                                                    <td>{ e.cedula }</td>
                                                    <td>{ esTitulado( e.es_titulado ) }</td>
                                                    <td>{ enlaceTitulo( e.es_titulado, e.archivo_cedula, infoEmpleado.email ) }</td>
                                                    <td>{ enlaceTitulo( e.es_titulado, e.archivo_titulo, infoEmpleado.email ) }</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Contactos de emergencia</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Teléfono</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactos.map((e, i) => (
                                                <tr key={i}>
                                                    <td>{e.nombre}</td>
                                                    <td>{e.telefono}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Experiencia como docente</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Año de inicio</th>
                                                <th>Año de finalización</th>
                                                <th>Escuela</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {expDocente.map((e, i) => (
                                                <tr key={i}>
                                                    <td>{e.inicio}</td>
                                                    <td>{e.final}</td>
                                                    <td>{e.empresa}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Experiencia en el sector productivo</Card.Header>
                                <Card.Body>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Año de inicio</th>
                                                <th>Año de finalización</th>
                                                <th>Puesto</th>
                                                <th>Empresa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {expSectorProductivo.map((e, i) => (
                                                <tr key={i}>
                                                    <td>{e.inicio}</td>
                                                    <td>{e.final}</td>
                                                    <td>{e.puesto}</td>
                                                    <td>{e.empresa}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>¿Usa lentes?</Card.Header>
                                <Card.Body>
                                    {
                                        (lentes.graduacion?.length > 0)
                                            ? <Table>
                                                <thead>
                                                    <tr>
                                                        <th width='30%'>Graduación de lentes</th>
                                                        <td align='left'>{lentes.graduacion}</td>
                                                    </tr>
                                                </thead>
                                            </Table>
                                            :
                                            <p className='lead'>No usa lentes</p>
                                    }
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Hijos</Card.Header>
                                <Card.Body>
                                    { hijos?.length > 0
                                        ? <Table>
                                            <thead>
                                                <tr>
                                                    <th>Edad</th>
                                                    <th>Guardería</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {hijos.map((e, i) => (
                                                    <tr key={i}>
                                                        <td>{e.edad}</td>
                                                        <td>{(e.guarderia?.length > 0) ? e.guarderia : 'No necesita guardería'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        : 'Sin registros' }
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Estudiando actualmente</Card.Header>
                                <Card.Body>
                                    { estudiosActuales?.length > 0
                                        ? <Table>
                                            <thead>
                                                <tr>
                                                    <th>Carrera</th>
                                                    <th>Institución</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {estudiosActuales.map((e, i) => (
                                                    <tr key={i}>
                                                        <td>{e.carrera}</td>
                                                        <td>{e.institucion}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        : 'Sin registros' }
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>¿Tienes algún problema auditivo u ortopédico?</Card.Header>
                                <Card.Body>
                                    { problemas?.length > 0
                                        ? <Table>
                                            <thead>
                                                <tr>
                                                    <th>Tipo de problema</th>
                                                    <th>Descripción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {problemas.map((e, i) => (
                                                    <tr key={i}>
                                                        <td>{e.tipo}</td>
                                                        <td>{e.problema}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        : 'Sin registros'}
                                </Card.Body>
                            </Card>

                            <Card className='mt-3'>
                                <Card.Header>Cuenta BBVA</Card.Header>
                                <Card.Body>
                                    {
                                        (cuentaBancaria.cuenta?.length > 0)
                                            ? <Table>
                                                <thead>
                                                    <tr>
                                                        <th width='30%'>Número de cuenta</th>
                                                        <td align='left'>{cuentaBancaria.cuenta}</td>
                                                    </tr>
                                                </thead>
                                            </Table>
                                            :
                                            <p className='lead'>No tiene cuenta BBVA</p>
                                    }
                                </Card.Body>
                            </Card>



                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalInfoEmpleado

